// import { throttle } from '@umu/umu-util';
import { getPrefixSupport, isPageVisibilitySupport } from './util';
import { $document } from '@umu/umu-dom';
import { throttle } from '@umu/umu-util';
import * as lifecycle from './lifecycle.es5';

type callbackFnc = (event: Event, status: string, count?: string | null) => void;

/**
 * 监听页面 Visibility 变化
 * @author Kody
 */
export class PageVisibility {
    public static instanceMap: { [key: string]: PageVisibility } = {};
    /**
     * 创建单例 PageVisibility
     * @param key 唯一标识
     * @param cb 回调
     * @returns PageVisibility
     */
    public static create = (key: string, cb: callbackFnc) => {
        if (PageVisibility.instanceMap[key]) {
            return PageVisibility.instanceMap[key];
        }
        const instanceObj = new PageVisibility(key, cb);
        PageVisibility.instanceMap[key] = instanceObj;
        return instanceObj;
    };

    // 移除缓存对象
    public static remove = (key: string) => {
        key = `switch_window_${key}`;
        localStorage.removeItem(key);
        localStorage.removeItem(`screen_switch_record_${key}`);
        delete PageVisibility.instanceMap[key];
    };

    public static getSwitchRecord = (key: string) => {
        const value = localStorage.getItem(`screen_switch_record_${key}`) || '[]';
        return JSON.parse(value);
    };

    public key = '';
    public switchkey = '';
    public watchTimer = 0;
    public avtiveState: DocumentVisibilityState = 'visible';
    public testDom: HTMLDivElement | null = null;
    public callback: callbackFnc | undefined = undefined; // 切屏回来的回调
    public prefixSupport = getPrefixSupport(); // 浏览器前缀
    public isSupport = isPageVisibilitySupport(); // 是否支持 visibilityState

    constructor(key: string, cb: callbackFnc) {
        if (cb) {
            this.callback = cb;
        }
        this.key = `switch_window_${key}`;
        this.switchkey = `screen_switch_record_${key}`;
        this.visibilitychange();
        const switchCount = this.getSwitchCount();
        if (switchCount) {
            this.setSwitchCount();
            cb(new Event('visibilitychange'), 'visible', this.getSwitchCount());
        } else {
            this.setSwitchCount(0);
        }
    }

    public avtiveChangeCallback = (avtiveState: DocumentVisibilityState) => {
        if (typeof this.callback === 'function') {
            this.callback(new Event('visibilitychange'), avtiveState, this.getSwitchCount());
        }
    };

    // public listenerHandle = (evt: Event) => {
    //     const avtiveState = this.visibilityState();
    //     if (avtiveState === 'hidden') {
    //         this.onPagehide(evt);
    //         return;
    //     }
    //     this.avtiveChangeCallback(evt, avtiveState);
    // };

    // public onPageshow = (evt: Event) => {
    //     if (typeof this.callback === 'function') {
    //         this.callback(evt, 'visible', this.getSwitchCount());
    //     }
    // };

    public onPagehide = throttle(() => {
        this.setSwitchCount();
        this.avtiveChangeCallback('hidden');
    }, 2000);

    public checkInit = () => {
        if (!this.key) {
            console.warn('Please create PageVisibility first!');
            return false;
        }
        return true;
    };

    public getSwitchCount = () => {
        if (!this.checkInit()) {
            return null;
        }
        const count = localStorage.getItem(this.key);
        return count;
    };

    public setSwitchCount = (count?: number) => {
        if (!this.checkInit()) {
            return;
        }
        if (count !== undefined) {
            localStorage.setItem(this.key, String(count));
            return count;
        }
        let activeCount = this.getSwitchCount();
        if (!activeCount) {
            activeCount = '0';
            localStorage.setItem(this.key, '0');
            return '0';
        }
        const nextCount = Number(activeCount) + 1;
        localStorage.setItem(this.key, String(nextCount));
        return nextCount;
    };

    public visibilityState = () => {
        if (this.isSupport) {
            return $document.visibilityState;
        } else {
            // 不支持 visibilityState，但是支持$document.hidden
            return $document.hidden ? 'hidden' : 'visible';
        }
    };

    public statechange = (event: any) => {
        if (event.oldState !== 'hidden' && event.newState !== 'hidden') {
            return;
        }

        const record = PageVisibility.getSwitchRecord(this.key);
        record.push(`${event.originalEvent.type}_${event.newState}_${Math.floor(Date.now() / 1000)}`);
        localStorage.setItem(this.switchkey, JSON.stringify(record));
    };

    public visibilitychange = () => {
        // setTimeout(() => {
        //     $document.addEventListener('visibilitychange', this.listenerHandle, false);
        //     $window.addEventListener('pageshow', this.onPageshow, false);
        // }, 2000);
        // $window.addEventListener('pagehide', this.onPagehide, false);
        // $window.addEventListener('beforeunload', this.onPagehide, false);

        // this.testDom = document.createElement('div');
        // this.testDom.classList.add('lifecycle');
        // this.testDom.innerHTML = localStorage.getItem('lifecycle') || '';
        // document.body.insertBefore(this.testDom, document.body.firstChild);

        lifecycle.addEventListener('statechange', this.statechange);

        this.watchTimer = window.setInterval(() => {
            const avtiveState = this.visibilityState();
            if (avtiveState !== this.avtiveState) {
                this.avtiveState = avtiveState;
                if (avtiveState === 'hidden') {
                    this.onPagehide();
                    return;
                }
                this.avtiveChangeCallback('visible');
            }
        }, 150);
    };

    public clear = () => {
        localStorage.removeItem(this.key);
        localStorage.removeItem(this.switchkey);
    };

    // 注销监听并清空 count
    public destroy = () => {
        clearInterval(this.watchTimer);
        lifecycle.removeEventListener('statechange', this.statechange);
        this.clear();
        // $document.removeEventListener('visibilitychange', this.listenerHandle, false);
        // $window.removeEventListener('pageshow', this.onPageshow, false);
        // $window.removeEventListener('pagehide', this.onPagehide, false);
        // $window.removeEventListener('beforeunload', this.onPagehide, false);
    };
}
